var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListComponent',{attrs:{"type":"commodityManage","merchant-products":_vm.merchantProducts,"service-category":_vm.serviceCategory,"table-checkbox-show":true}})}
var staticRenderFns = []

export { render, staticRenderFns }